import { FC } from 'react';
import { LinkDriveSetupSteps } from './LinkDriveSetupSteps/LinkDriveSetupSteps';

export const LinkDriveSetupStepsPage: FC = () => {
  return <LinkDriveSetupSteps />;
};
